import { ENVIRONMENTS } from "@consts";

export const DEV_FAVICON_HREF = "/favicon-dev.svg";
export const PRODUCTION_FAVICON_HREF = "/favicon.ico";

const DEV_BRANDING = { titlePrefix: "[DEV] ", faviconHref: DEV_FAVICON_HREF };
const BRANCH_BRANDING = { titlePrefix: "[BD] ", faviconHref: DEV_FAVICON_HREF };
const PRODUCTION_BRANDING = { titlePrefix: "", faviconHref: PRODUCTION_FAVICON_HREF };

export const resolveEnvironmentBranding = (environment) =>
  ({
    [ENVIRONMENTS.LOCAL]: DEV_BRANDING,
    [ENVIRONMENTS.DEVELOPMENT]: DEV_BRANDING,
    [ENVIRONMENTS.BRANCH]: BRANCH_BRANDING,
    [ENVIRONMENTS.PRODUCTION]: PRODUCTION_BRANDING
  }[environment] ?? PRODUCTION_BRANDING);

const applyFavicon = (faviconHref) => {
  if (faviconHref === PRODUCTION_FAVICON_HREF) return;

  const link = document.querySelector("link[rel='shortcut icon']")
    ?? document.head.appendChild(Object.assign(document.createElement("link"), { rel: "shortcut icon" }));

  link.type = faviconHref.endsWith(".svg") ? "image/svg+xml" : "image/x-icon";
  link.href = faviconHref;
};

const applyTitlePrefix = (titlePrefix) => {
  if (!titlePrefix || document.title.startsWith(titlePrefix)) return;

  document.title = `${titlePrefix}${document.title}`;
};

export const applyEnvironmentBranding = (environment = import.meta.env.VITE_ENV) => {
  const { titlePrefix, faviconHref } = resolveEnvironmentBranding(environment);

  applyFavicon(faviconHref);
  applyTitlePrefix(titlePrefix);
};
